import type { DataRequestFieldResponse } from "../../models/data-request.model";

import type { FieldDraft } from "./use-draft-persistence";

interface ResolveFieldInitialValueArgs {
  draft: FieldDraft | null;
  savedResponse: DataRequestFieldResponse | null;
  defaultValue: string | null;
}

/** The row renders this and the date pickers bound each other by it, so the two have to agree on the order. */
export function resolveFieldInitialValue({
  draft,
  savedResponse,
  defaultValue,
}: ResolveFieldInitialValueArgs): string {
  if (draft?.newValue !== null && draft?.newValue !== undefined) {
    return String(draft.newValue);
  }
  if (savedResponse?.newValue !== null && savedResponse?.newValue !== undefined) {
    return String(savedResponse.newValue);
  }
  return defaultValue ?? "";
}
